import React from "react";
import { ReactComponent as ChairSvg } from "../svg/chair.svg";

export default function ChairIcon({ size = 64, color = "#32363F", ...props }) {
  return <ChairSvg width={size} height={size} style={{ color }} {...props} />;
}
